<template>
  <div>
    <b-breadcrumb size="is-large" separator="has-succeeds-separator" aria-label="breadcrumbs">
      <b-breadcrumb-item active>
        {{ $t('global.events') }}
      </b-breadcrumb-item>
    </b-breadcrumb>
    <EventsStreamTable :topics="['#']" :showDisconnectedOverlay="true" />
  </div>
</template>

<script lang="ts">
import EventsStreamTable from '@/components/EventsStreamTable.vue'

export default {
  components: { EventsStreamTable },
};
</script>

<style scoped>
</style>
